import styled from 'styled-components';

import { ISpecOffer } from '@r1-frontend/api-domru/spec-offer/v1/spec-offers';

import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { FullWidthListContainer, IndentContainer, NonStaticContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { textOverflowLineClamp } from '@r1-frontend/ui-react/tokens/others/textOverflowLineClamp';

import { Content } from '~/src/components/Drawer';

export const SContent = styled(Content)<{ bgColor: string }>`
    height: 100%;
    background-color: ${({ bgColor }) => bgColor};

    & > ${FullWidthListContainer} {
        min-height: 100%;

        & > ${NonStaticContainer} {
            margin-top: auto;
        }
    }
`;

export const Title = styled(H3)<{ $textColor: ISpecOffer['textColor'] }>`
    color: ${({ $textColor = COLORS.TextPrimary }) => $textColor};
    text-align: center;
    margin: 0 auto;
    ${textOverflowLineClamp(3)};
`;

export const FooterContent = styled(IndentContainer)`
    width: 100%;
    background-color: ${COLORS.BgMain};
`;
